// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__openSansRegular_ff77b2', '__openSansRegular_Fallback_ff77b2', s, e, r, i, f","fontStyle":"normal"},"className":"__className_ff77b2"};